import * as React from "react";
export class ScoreboardCell extends React.PureComponent {
    render() {
        return (React.createElement("td", { className: `rj-aggregate-scoreboard-cell ${this.props.columnClass}` },
            React.createElement("span", { className: this.props.contentClass }, this.props.content)));
    }
}
export const ScoreboardCellContent = (props) => (React.createElement(ScoreboardCell, Object.assign({}, props, { contentClass: "rj-aggregate-scoreboard-cell-content" })));
export const ScoreboardCellScore = (props) => (React.createElement(ScoreboardCellContent, Object.assign({}, props, { columnClass: "rj-aggregate-scoreboard-cell--score" })));
//# sourceMappingURL=ScoreboardCell.js.map